/****
 * Vars for Service Worker and Indexed DB
 * If change here, need to change in "sw-indexed-db.js" in public folder
 * */

export const indexedDBName = 'GaiaPwaDB'
export const indexedDBVersion = 2
